module.exports = __webpack_public_path__ + "static/media/Icon2.45c8b01b.png";